<template>
  <section id="product-detail">
    <div class="inner">
      <Form @submit="validSubmitProduct" @invalid-submit="invalidSubmitProduct">
        <Lovers v-if="product.category_id === 1" />
        <Insta v-if="product.category_id === 2" />
        <Music v-if="product.category_id === 3" />
        <Custom v-if="product.category_id === 4" />
        <Photo v-if="product.category_id === 5" />
        <Accessory v-if="product.category_id === 6" />
        <Illustration v-if="product.category_id === 7" />
      </Form>
    </div>
  </section>
</template>
<script>
import { mapGetters, mapMutations } from "vuex";
import { Form } from "vee-validate";
import Accessory from "./partials/Accessory";
import Lovers from "./partials/Lovers";
import Insta from "./partials/Insta";
import Music from "./partials/Music";
import Photo from "./partials/Photo";
import Custom from "./partials/Custom";
import Illustration from "./partials/Illustration";
import useProduct from "./useProduct";

export default {
  components: {
    Accessory,
    Custom,
    Photo,
    Music,
    Insta,
    Lovers,
    Form,
    Illustration,
  },
  props: {
    productItem: {
      type: String,
    },
    attributeItems: {
      type: String,
    },
    products: {
      type: String,
    },
    currentLanguage: {
      type: Object,
    },
  },
  computed: {
    ...mapGetters("product", {
      product: "getProduct",
    }),
  },
  methods: {
    ...mapMutations("language",["SET_CURRENT_LANGUAGE"]),
    setupData() {
      this.setAttributes(this.attributeItems);

      this.setProduct(this.productItem);
    },
  },
  setup(props) {
    const {
      setProduct,
      setAttributes,
      invalidSubmitProduct,
      validSubmitProduct,
    } = useProduct();

    return {
      setProduct,
      setAttributes,
      invalidSubmitProduct,
      validSubmitProduct,
    };
  },
  created() {
    this.setupData();

    this.$store.commit('cart/SET_PRODUCTS', this.products);

    this.SET_CURRENT_LANGUAGE(JSON.parse(this.currentLanguage));
  },
};
</script>
